import { ConnectedAppAuthType } from '~/api/types/connectedAppProviders.ts';

export enum ConnectedAccountStatus {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  PENDING_AUTH = 'PENDING_AUTH'
}

export interface ConnectedAccountData {
  id: string;
  identifier: string;
  provider: string;
  status: ConnectedAccountStatus;
  authorizationType: ConnectedAppAuthType;
  tokenExpiresAt: string;
  updatedAt: string;
  connector: string;
  connectionId: string;
  lastUsedAt: string;
  authorizationDetails: {
    staticAuth?: {
      details?: Record<string, any>;
    };
  };
  apiConfig?: Record<string, any>;
}
